import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorToPledgeMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M6.65 10.704c0 1.52.52 2.906 1.38 3.982a4.728 4.728 0 0 1 2.172-.528h3.762a1.5 1.5 0 0 1 1.12.501l.478.537 1.443-1.312c.267-.242.58-.406.909-.492a6.42 6.42 0 0 0 .583-2.688c0-3.456-2.681-6.204-5.924-6.204-3.242 0-5.923 2.748-5.923 6.204Zm.173 4.874a7.856 7.856 0 0 1-1.673-4.873C5.15 6.478 8.444 3 12.573 3c4.13 0 7.424 3.479 7.424 7.704a7.94 7.94 0 0 1-.531 2.868 2.16 2.16 0 0 1 .498 3.46l-2.897 2.814a4.317 4.317 0 0 1-3.008 1.221H4.038v-1.5h10.02c.734 0 1.438-.286 1.964-.796l2.896-2.815a.66.66 0 0 0-.904-.962l-1.95 1.773-.7.934a.75.75 0 0 1-.6.3h-3.526v-1.5h3.15l.15-.2-.574-.643h-3.762a3.23 3.23 0 0 0-2.68 1.427 2.077 2.077 0 0 1-1.723.917H4v-1.5h1.799a.577.577 0 0 0 .479-.255c.162-.241.345-.465.545-.67Z"
    />
    <path
      fill="#F7A600"
      d="M12.398 7.652a.24.24 0 0 1 .454 0l.57 1.64h1.797a.24.24 0 0 1 .135.438l-1.44.978.559 1.607a.24.24 0 0 1-.362.278l-1.486-1.01-1.486 1.01a.24.24 0 0 1-.362-.277l.559-1.608-1.44-.978a.24.24 0 0 1 .135-.438h1.797l.57-1.64Z"
    />
  </svg>
);
export default SvgTwoColorToPledgeMoney;
